import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="colophon" data-id="element-14">
      <nav className="colophon-col is-links" data-id="element-15">
        <a href="https://ai.andoe.work/" target="_blank" rel="noopener noreferrer" data-id="element-16">
          Login
        </a>
        <Link to="/about" data-id="element-17">About</Link>
        <Link to="/switch" data-id="element-18">Switch to Andoe</Link>
        <Link to="/contact" data-id="element-19">Contact</Link>
      </nav>
      <nav className="colophon-col is-links" data-id="element-20">
        <Link to="/privacy" data-id="element-21">Privacy</Link>
        <Link to="/terms" data-id="element-22">Terms</Link>
      </nav>
      <div className="colophon-side" data-id="element-23">
        <div className="colophon-copy" data-id="element-24">
          <span className="mark" aria-hidden="true" data-id="element-25">
            <svg viewBox="0 0 32 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-26">
              <path d="M0 0 H29 A3 3 0 0 1 32 3 V8 H0 Z" data-id="element-27" />
              <rect x="24" y="0" width="8" height="24" data-id="element-28" />
              <rect x="0" y="13" width="8" height="8" data-id="element-29" />
              <rect x="12" y="13" width="8" height="8" data-id="element-30" />
            </svg>
          </span>
          Andoe ©2026
        </div>
        <div className="colophon-social" data-id="element-31">
          <a href="https://www.linkedin.com/company/andoe/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" data-id="element-32">
            <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-33">
              <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.36V9h3.41v1.56h.05c.48-.9 1.63-1.85 3.36-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45C23.21 24 24 23.23 24 22.28V1.72C24 .77 23.21 0 22.22 0z" data-id="element-34" />
            </svg>
          </a>
        </div>
      </div>
    </footer>;
}